import { defineComponent as n, createElementBlock as c, openBlock as o, Fragment as h, createVNode as t, createBlock as y, createCommentVNode as B, withCtx as a, createTextVNode as m } from "vue";
import d from "./ParameterList.vue.js";
import f from "./RequestBody.vue.js";
const V = /* @__PURE__ */ n({
  __name: "OperationParameters",
  props: {
    breadcrumb: {},
    parameters: { default: () => [] },
    requestBody: {},
    schemas: {}
  },
  emits: ["update:modelValue"],
  setup(b, { emit: u }) {
    const i = u, p = (e) => {
      i("update:modelValue", e);
    }, s = (e) => {
      var r;
      return ((r = b.parameters) == null ? void 0 : r.filter((l) => l.in === e)) ?? [];
    };
    return (e, r) => (o(), c(h, null, [
      t(d, {
        breadcrumb: e.breadcrumb ? [...e.breadcrumb, "path"] : void 0,
        parameters: s("path"),
        schemas: e.schemas
      }, {
        title: a(() => r[0] || (r[0] = [
          m("Path Parameters")
        ])),
        _: 1
      }, 8, ["breadcrumb", "parameters", "schemas"]),
      t(d, {
        breadcrumb: e.breadcrumb ? [...e.breadcrumb, "query"] : void 0,
        parameters: s("query"),
        schemas: e.schemas
      }, {
        title: a(() => r[1] || (r[1] = [
          m("Query Parameters")
        ])),
        _: 1
      }, 8, ["breadcrumb", "parameters", "schemas"]),
      t(d, {
        breadcrumb: e.breadcrumb ? [...e.breadcrumb, "headers"] : void 0,
        parameters: s("header"),
        schemas: e.schemas
      }, {
        title: a(() => r[2] || (r[2] = [
          m("Headers")
        ])),
        _: 1
      }, 8, ["breadcrumb", "parameters", "schemas"]),
      t(d, {
        breadcrumb: e.breadcrumb ? [...e.breadcrumb, "cookies"] : void 0,
        parameters: s("cookie"),
        schemas: e.schemas
      }, {
        title: a(() => r[3] || (r[3] = [
          m("Cookies")
        ])),
        _: 1
      }, 8, ["breadcrumb", "parameters", "schemas"]),
      e.requestBody ? (o(), y(f, {
        key: 0,
        breadcrumb: e.breadcrumb ? [...e.breadcrumb, "body"] : void 0,
        requestBody: e.requestBody,
        schemas: e.schemas,
        "onUpdate:modelValue": p
      }, {
        title: a(() => r[4] || (r[4] = [
          m("Body")
        ])),
        _: 1
      }, 8, ["breadcrumb", "requestBody", "schemas"])) : B("", !0)
    ], 64));
  }
});
export {
  V as default
};
